import { floatVal, values } from "@jamesgmarks/utilities";
import { ETieredUnitCountSingleFamilyChargeStrategy } from "@llws/hydra-shared";
import {
  FormControlLabel, Grid, InputAdornment, MenuItem, Select, TextField,
} from "@mui/material";
import { useState } from "react";
import { ChargeStrategyEnum, TChargeStrategy } from "src/components/pages/Subscriptions/form/CustomConfigEditor/customConfigMeta";

interface ISingleFamilyTierProps {
  pricePerUnit: number;
  chargeStrategy: TChargeStrategy;
  onChange: (
    pricePerUnit: number,
    chargeStrategy: TChargeStrategy,
  ) => void;
}

interface ISingleFamilyTierFormData {
  pricePerUnit: string;
}

export const SingleFamilyTierComponent: React.FC<ISingleFamilyTierProps> = ({
  pricePerUnit,
  chargeStrategy,
  onChange,
}) => {
  const [formData, setFormData] = useState<ISingleFamilyTierFormData>({
    pricePerUnit: `${pricePerUnit}`,
  });

  return (
    <>
      <Grid item xs={3}>
        <TextField
          label="Price per unit"
          type="text"
          size="small"
          sx={{ background: "white" }}
          value={formData.pricePerUnit}
          onChange={(e) => {
            if (/^(0|[1-9]\d*)?(\.\d{0,2})?$/.test(e.target.value)) {
              setFormData((old) => ({ ...old, pricePerUnit: e.target.value }));
            }
          }}
          onBlur={() => {
            if (['', '.'].includes(formData.pricePerUnit)) {
              setFormData((old) => ({ ...old, pricePerUnit: '0' }));
              onChange(0, chargeStrategy);
              return;
            }

            onChange(floatVal(formData.pricePerUnit), chargeStrategy);
          }}
          InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
          }}
        />
      </Grid>

      <Grid item container xs={12} mt={1} pt={1} justifyContent='center'>
        <FormControlLabel
          label="Charge strategy:"
          labelPlacement="top"
          control={
            <Select
              value={chargeStrategy}
              size='small'
              onChange={(e) => {
                const chargeStrategyParsed = ChargeStrategyEnum.safeParse(e.target.value);
                if (chargeStrategyParsed.success) {
                  onChange(pricePerUnit, chargeStrategyParsed.data);
                }
              }}
              sx={{ minWidth: 200, mt: 1 }}
            >
              {
                values(ETieredUnitCountSingleFamilyChargeStrategy).map((strategy) => (
                  <MenuItem key={strategy} value={strategy}>
                    {strategy}
                  </MenuItem>
                ))
              }
            </Select>
          }
        />
      </Grid>
    </>
  );
};
